import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronDoubleUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7.2 10.8 12 6l4.8 4.8M7.2 18l4.8-4.8 4.8 4.8"
    />
  </svg>
);
export default SvgChevronDoubleUp;
